<div *ngIf="softsubscribers.length">Excelfil med SOFT-prenumeranter skapad. Antal poster: {{softsubscribers.length}}</div>
<div *ngIf="working">Hämtar data...</div>